import {ViewType} from "./view-type"

export function getViewSystemType(viewType: ViewType): ViewType {
    switch (viewType) {
        case ViewType.CUSTOM_VIEW_TASKS_TABLE:
        case ViewType.PROJECT_TABLE:
        case ViewType.PORTFOLIO_TABLE:
            return ViewType.PROJECT_TABLE

        case ViewType.CUSTOM_VIEW_BOARD:
        case ViewType.PROJECT_BOARD:
        case ViewType.PORTFOLIO_BOARD:
            return ViewType.PROJECT_BOARD

        case ViewType.CUSTOM_VIEW_TASKS_LIST:
        case ViewType.PROJECT_LIST:
        case ViewType.PORTFOLIO_LIST:
        case ViewType.MY_TASKS_LIST:
            return ViewType.PROJECT_LIST

        case ViewType.CUSTOM_VIEW_GANTT:
        case ViewType.PROJECT_GANTT:
        case ViewType.PORTFOLIO_GANTT:
            return ViewType.PROJECT_GANTT

        case ViewType.CUSTOM_VIEW_WORKLOAD:
        case ViewType.PROJECT_WORKLOAD:
        case ViewType.PORTFOLIO_WORKLOAD:
            return ViewType.PROJECT_WORKLOAD

        case ViewType.MY_WORK_CALENDAR:
        case ViewType.PORTFOLIO_CALENDAR:
        case ViewType.CUSTOM_VIEW_CALENDAR:
        case ViewType.PROJECT_CALENDAR:
            return ViewType.PROJECT_CALENDAR

        case ViewType.CUSTOM_VIEW_PROJECTS_TABLE:
        case ViewType.PROJECTS_PROJECTS_LIST:
        case ViewType.REPORT_TIME_REPORTS:
            return ViewType.CUSTOM_VIEW_PROJECTS_TABLE

        case ViewType.PROJECT_TABLE_MAP:
            return ViewType.PROJECT_TABLE_MAP

        case ViewType.PORTFOLIO_SUMMARY:
        case ViewType.PROJECT_SUMMARY:
            return ViewType.PORTFOLIO_SUMMARY

        case ViewType.MY_TIME:
            return ViewType.MY_TIME

        default:
            throw new Error("#4kjhd9dd Unknown view type")
    }
}